export const fees = {
  mandatory_tax: {
    label: 'Tasse di soggiorno',
    tooltip: 'La tassa di soggiorno viene definita dall\'Amministrazione Comunale, è quindi soggetta a variazioni oppure l\'hotel potrebbe avere inserito dati non corretti. Se desideri informazioni definitive consulta il sito del Comune o contatta la struttura alberghiera.',
  }
}

export function get_fees(key) {
  if (fees[key] !== undefined) return fees[key]
  return { label: key, tooltip: '' }
}